<template>
  <v-container p-0>
    <v-row class="my-0">
      <v-col class="pt-0 pb-0 my-0" cols="12">
        <div class="subtitle-1">{{ $t('LoggedArea.Followers.Title') }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  
}
</script>

<style>
</style>